import styled from 'styled-components';
import { palette } from 'styled-tools';

import { CONTENT_MAX_WIDTH, minWidth } from '@calm-web/design-system';

import LeBronCalmLogoVector from '@/../public/_n/images/lebron/lebron-calm-logo.svg';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 100vh;
`;

export const Container = styled.div`
	${minWidth('tablet')} {
		display: grid;
		grid-template-columns: 50% 50%;
		margin-bottom: auto;
	}
`;

export const Column = styled.div`
	min-height: 440px;
	position: relative;
`;

export const BgVideo = styled.div`
	height: 100%;
	position: absolute;
	top: 0;
	width: 100%;
	z-index: -1;

	& video {
		height: 100%;
		object-fit: cover;
		object-position: center;
		width: 100%;
	}
`;

export const Content = styled.div`
	margin-left: auto;
	padding: 136px 16px 52px;

	${minWidth('mobileLarge')} {
		padding: 136px 24px 52px;
	}

	${minWidth('tablet')} {
		padding: 136px 36px 52px 24px;
	}

	${minWidth('desktop')} {
		max-width: 480px;
		padding: 200px 24px 100px 0;
		width: 100%;
	}

	${minWidth('desktopLarge')} {
		max-width: ${CONTENT_MAX_WIDTH / 2}px;
		padding: 200px 84px 100px 0;
	}
`;

export const Heading = styled.h1`
	color: ${palette('white')};
	font-family: 'Neue Plak';
	font-size: 36px;
	line-height: 100%;
	margin-bottom: 40px;
	text-transform: uppercase;

	${minWidth('desktop')} {
		font-size: 44px;
		margin-bottom: 48px;
	}
`;

export const LeBronLogo = styled(LeBronCalmLogoVector)`
	height: auto;
	margin-bottom: 40px;
	width: 250px;

	${minWidth('desktop')} {
		margin-bottom: 80px;
		width: 284px;
	}
`;
